import { createStore } from '@store/createStore';

const useModalStore = createStore((set) => ({
  activeModalName: { name: null, options: null, awayClick: false },
  secondaryModal: { name: null, options: null },
  actions: {
    setActiveModal: ({ name, options = {}, awayClick = false }) =>
      set({ activeModalName: { name, options, awayClick } }),
    setSecondaryModal: ({ name, options = {} }) => set({ secondaryModal: { name, options } }),
    setModalClose: () => set({ activeModalName: { name: null, options: null, awayClick: false } }),
    setSecondaryModalClose: () => set({ secondaryModal: { name: null, options: null } }),
  },
}));

export const useModalActions = () => useModalStore((state) => state.actions);

export const selectActiveModal = () => useModalStore((state) => state.activeModalName);
export const selectSecondaryModal = () => useModalStore((state) => state.secondaryModal);
